<template lang="pug">
form.column.is-offset-3.is-half(@submit.prevent="submitComment")
    .columns
        .field.column
            label.label(for="username") Benutzername
            .control.has-icons-right
                input#username.input(type="text")
                span.icon.is-small.is-right
                    i.fas.fa-user
            p.help.has-text-grey Pflicht
        .field.column
            label.label(for="email") E-Mail Adresse
            .control.has-icons-right
                input#email.input(type="email")
                span.icon.is-small.is-right
                    i.fas.fa-envelope
            p.help.has-text-grey Pflicht
    // .field
    //     label.label Ihre Bewertung
    //     StarRating( v-model="rating"
    //         :increment="1"
    //         :read-only="false"
    //         :show-rating="false"
    //         :max-rating="stars"
    //         :star-size="20"
    //     )
    .field
        label.label(for="body") Ihr Kommentar
        .control
            textarea.textarea#body
        p.help.has-text-grey Pflicht
    .field.is-pulled-left
        .control
            label.checkbox
                input(type="checkbox")
                |  Ich stimme den Datenschutzbestimmungen zu
    .field.is-pulled-right
        .control
            button.button.is-primary(type="submit") Absenden
    .is-clearfix
</template>
<script>
import store from '@/store';

export default {
    name: 'CommentInput',
    data() {
        return {
            rating: null,
            stars: 5,
        }
    },
    props: {
        pageId: {
            required: true,
            type: Number
        }
    },
    methods: {
        submitComment(submitEvent) {

            // TODO
            // loader

            let finalRating
            if (this.rating || this.rating != 'undefined') {
                finalRating = this.rating * ( 100 / this.stars )
            }

            let formData = {
                "username": submitEvent.target.elements[0].value,
                "email": submitEvent.target.elements[1].value,
                "body": submitEvent.target.elements[2].value,
                "rating": finalRating,
                "page_id": this.pageId,
            }
            submitEvent.target.reset();
            store.dispatch('sendCommentToApi', formData)
                .then(data => {
                    // TODO
                    // remove loader
                    // add new comment / or request fresh paginated comments
                })
        }
    }
}
</script>
<style lang="sass" scoped>
    form
        margin-bottom: 60px
</style>
